/**
 * @generated SignedSource<<990c269301fc7173301202307e7bbe97>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type tagFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "tagFragment";
};
export type tagFragment$key = {
  readonly " $data"?: tagFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"tagFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "tagFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Tag",
  "abstractKey": null
};

(node as any).hash = "e54dff492851ff154c2624e05cec16a8";

export default node;
